<template>
  <main class="main register max-width amateur">
    <article v-if="user && user.id">
      <h1 class="title-medium">Registrati</h1>
      <p>Sei già registrato come {{user.name}}. Vai al <router-link class="green-link" to="/catalog">catalogo</router-link> oppure effettua <a class="green-link" href="#0" @click.prevent="logout">il logout</a>.</p>
    </article>
    <article v-else>
      <h1 class="title-medium">Registrati</h1>
      <p>Compila i campi sottostanti per ottenere le tue credenziali personali e avere accesso ai contenuti esclusivi del nostro sito.</p>
      <p>La categoria "professionisti" è riservata a coloro che effettuano almeno 40-50 servizi annuali. Gli utenti che dichiarano di appartenere a tale categoria sono invitati ad inviare la loro programmazione musicali compilando l'apposito form del sito. Questo garantirà l'invio periodico delle nostre novità!</p>
      <p id="account-type">
        <span>Scegli il tipo di account più adatto a te:</span>
        <a href="#0" class="button button-regular button-aqua button-anim" :class="{unselected: type != 'appassionato'}" @click.prevent="setAccountType('appassionato')">Appassionato</a>
        <a href="#0" class="button button-regular button-aqua button-anim" :class="{unselected: type != 'professionista'}" @click.prevent="setAccountType('professionista')">Professionista</a>
      </p>


      <!-- data-request="onRegister" --> 
      <form class="register-form" @submit.prevent="onSubmit" v-if="isFormVisible">
        <div class="row row-2">
          <div class="input-block">
            <label for="email" class="form-label" style="opacity: 0;" ref="email">Email utente</label>
            <input v-model="form.email" name="email" type="email" class="form-control" placeholder="Email utente">
            <div class="message" v-if="isInputEmpty.email">L'email è richiesta</div>
          </div>

          <div class="input-block">
            <label for="password" class="form-label" style="opacity: 0;" ref="password">Password</label>
            <input v-model="form.password" name="password" type="password" class="form-control" placeholder="Password">
            <div class="message" v-if="isInputEmpty.password">La password è richiesta</div>
          </div>
        </div>

        <div class="row row-2">
          <div class="input-block">
            <label for="name" class="form-label" ref="name">Nome</label>
            <input v-model="form.name" type="text" name="name" placeholder="Nome">
            <div class="message" v-if="isInputEmpty.name">Il nome è richiesto</div>
          </div>
          <div class="input-block">
            <label for="surname" class="form-label" ref="surname">Cognome</label>
            <input v-model="form.surname" type="text" name="surname" placeholder="Cognome">
            <div class="message" v-if="isInputEmpty.surname">Il cognome è richiesto</div>
          </div>
        </div>

        <div class="row row-1">
          <div class="input-block">
            <label for="phone" class="form-label" ref="phone">Telefono</label>
            <input v-model="form.phone" type="tel" name="phone" placeholder="Telefono">
            <div class="message" v-if="isInputEmpty.phone">Il telefono è richiesto</div>
          </div>
        </div>

        <div class="row row-1">
          <div class="input-block">
            <label for="address" class="form-label" ref="address">Indirizzo</label>
            <input v-model="form.address" type="text" name="address" placeholder="Indirizzo">
            <div class="message" v-if="isInputEmpty.address">L'indirizzo è richiesto</div>
          </div>
        </div>

        <div class="row row-2">
          <div class="input-block">
            <label for="city" class="form-label" ref="city">Città</label>
            <input v-model="form.city" type="text" name="city" placeholder="Città">
            <div class="message" v-if="isInputEmpty.city">La città è richiesta</div>
          </div>
          <div class="input-block">
            <label for="prov" class="form-label" ref="prov">Provincia</label>
            <input v-model="form.prov" type="text" name="prov" placeholder="Provincia" maxlength="2">
            <div class="message" v-if="isInputEmpty.prov">La provincia è richiesta</div>
          </div>
          <div class="input-block">
            <label for="zip" class="form-label" ref="zip">CAP</label>
            <input v-model="form.zip" type="text" name="zip" placeholder="CAP" maxlength="5">
            <div class="message" v-if="isInputEmpty.zip">Il CAP è richiesto</div>
          </div>
        </div>

        <div class="row row-2">
          <div class="input-block">
            <label for="instrument" class="form-label" ref="instrument">Strumento</label>
            <input v-model="form.instrument" type="text" name="instrument" placeholder="Strumento">
            <div class="message" v-if="isInputEmpty.instrument">Lo strumento è richiesto</div>
          </div>
          <div class="input-block">
            <label for="orchestra" class="form-label" ref="orchestra">Orchestra</label>
            <input v-model="form.orchestra" type="text" name="orchestra" placeholder="Orchestra">
            <div class="message" v-if="isInputEmpty.orchestra">L'orchestra è richiesta</div>
          </div>
          <div class="input-block">
            <label for="media_serate_anno" class="form-label">Media delle serate in un anno</label>
            <input v-model="form.media_serate_anno" type="number" name="media_serate_anno" placeholder="Media delle serate in un anno" min="0">
            <div class="message" v-if="isInputEmpty.media_serate_anno">La media delle serate in un anno è richiesta</div>
          </div>
        </div>




        <div class="checkboxes">
          <!-- <label class="control-checkbox">Sono interessato a ricevere materiale informativo della vostra offerta
            <input type="checkbox" name="contact_consent" checked ref="contact_consent">
            <div class="control-indicator"></div>
          </label>
          -->
          <label class="control-checkbox">Sono interessato a ricevere la mailing list con le vostre novità

            <input v-model="form.newsletter_consent" type="checkbox" name="newsletter_consent" ref="newsletter_consent">
            <span></span>


            <div class="control-indicator"></div>
          </label>

          <label ref="privacy_consent" class="control-checkbox">Letta l'<router-link to="/privacy" target="_blank">informativa privacy</router-link>, acconsento al trattamento dei miei dati personali per le finalità indicate
            <input v-model="form.privacy_consent" type="checkbox" name="privacy_consent">
            <div class="control-indicator"></div>
            <div class="message" v-if="isInputEmpty.privacy_consent">È obbligatorio accettare l'informativa privacy</div>
          </label>
        </div>
        
        <!--<div class="g-recaptcha" id="re_captcha" data-sitekey="6Lcq1BkUAAAAAKG4PloXyjPJd5MgjXreaDndka5c"></div>-->
        <input type="submit" id="register-submit" class="button button-big button-aqua button-anim" value="ISCRIVITI" :disabled="!isPrivacyConsent">
      </form>
    </article>

    <error-warning 
      :isError="signupIsError"
      @close="signupIsError = false"
      bgColor="aqua" 
      message="Spiacenti, non è stato possibile registrare il nuovo utente.<br>Per favore, prima di riprovare, controlla tutti i campi, e di non avere già registrato un altro utente con lo stesso indirizzo email.">
    </error-warning>
  </main>
</template>

<script>
import axios from 'axios/dist/axios';
import ErrorWarning from './ErrorWarning';
import scrollTo from './../utils/scroll-to.js';

export default {
  props: ['user'],
  
  data() {
    return {
      type: '',
      isFormVisible: false,
      isPrivacyConsent: true,
      signupIsError: false,

      form: {
        email: '',
        password: '',
        name: '',
        surname: '',
        phone: '',
        address: '',
        city: '',
        prov: '',
        zip: '',
        instrument: '',
        orchestra: '',
        media_serate_anno: '',
        newsletter_consent: '',
        privacy_consent: ''
      },

      isInputEmpty: {
        email: false,
        password: false,
        name: false,
        surname: false,
        phone: false,
        address: false,
        city: false,
        prov: false,
        zip: false,
        instrument: false,
        orchestra: false,
        media_serate_anno: false,
        privacy_consent: false
      }
    }
  },

  methods: {
    logout: function() {
      this.$eventBus.$emit('user:logout', {});
    },
  
    setAccountType: function(type) {
      this.type = type;
      this.isFormVisible = true;
    },

    onSubmit: function(e) {
      const isValid = this.checkInputs();

      if(isValid) {
        const data = JSON.parse(JSON.stringify(this.form));
        data.password_confirmation = data.password;
        data.is_pro = this.type == 'professionista';
        //data.newsletter_consent = (data.newsletter_consent == true) ? 1 : 0;

        axios.post('/api/v1/user/signup', data)
          .then(resp => this.$router.push('/signup-success'))
          .catch(err => this.signupIsError = true);
      } else {
        // find the first available error
        const emptyFields = Object.keys(this.form).filter(key => this.isInputEmpty[key]);
        const targetY = this.$refs[emptyFields[0]].offsetTop - 200;
        scrollTo(targetY, 700, 'easeInOutQuint');        
      }
    },

    checkInputs() {
      this.isInputEmpty.email = !this.isPresent(this.form.email);
      this.isInputEmpty.password = !this.isPresent(this.form.password);
      this.isInputEmpty.name = !this.isPresent(this.form.name);
      this.isInputEmpty.surname = !this.isPresent(this.form.surname);
      this.isInputEmpty.phone = !this.isPresent(this.form.phone);
      this.isInputEmpty.address = !this.isPresent(this.form.address);
      this.isInputEmpty.city = !this.isPresent(this.form.city);
      this.isInputEmpty.prov = !this.isPresent(this.form.prov);
      this.isInputEmpty.zip = !this.isPresent(this.form.zip);
      this.isInputEmpty.media_serate_anno = !this.isPresent(this.form.media_serate_anno);
      this.isInputEmpty.instrument = !this.isPresent(this.form.instrument);
      this.isInputEmpty.orchestra = !this.isPresent(this.form.orchestra);
      this.isInputEmpty.privacy_consent = !this.isPresent(this.form.privacy_consent);

      return !Object.values(this.isInputEmpty).some(this.isTrue);
    },

    isTrue(el) {
      return el === true;
    },

    isPresent(data) {
      return data && data != '';
    }
  },

  components: {
    'error-warning': ErrorWarning
  },

  mounted() {
    document.title = 'Caramba - Registrati';
  }
}
</script>

<style lang="scss" scoped>
@import './../css/variables.css';

.message {
  background: var(--aqua);
  padding: 2px 5px;
  font-size: 14px;
  display: inline-block;
  line-height: 14px;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/vue/components/Signup.vue